module.exports = __webpack_public_path__ + "img/Protecting-Harvests-Rubber-Tapping-1110x450.2a4ecafe.png";